
import { Button, Modal, Box, CardContent, Autocomplete, Divider, Grid, TextField, Typography, Checkbox, FormControlLabel, Radio, FormControl, FormLabel, RadioGroup } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomLabel from '../../../CustomLable'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
//import { Props } from 'react-apexcharts';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useFormik } from 'formik';
import { toast, ToastContainer } from 'react-toastify';
import ToastApp from '../../../ToastApp';
import api from '../../../utils/Url';
import { getId, getISTDate } from "../../../utils/Constant";
import nopdf from '../../../assets/images/imagepreview.jpg'
import * as Yup from "yup";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
type Props = {};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

const CreateComplaint = (props: Props) => {
  let navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const [itemData, setItemData] = useState([{ value: "-1", label: t("text.SelectItemId") }]);
  const { defaultValues } = getISTDate();
  const [toaster, setToaster] = useState(false);
  const [Img, setImg] = useState("");
  const [approveEmp1, setApproveEmp1] = useState<any>('');
  const [approveEmp2, setApproveEmp2] = useState<any>('');
  const [approveEmp3, setApproveEmp3] = useState<any>('');
  const [approveEmp4, setApproveEmp4] = useState<any>('');

  const [editorContent, setEditorContent] = useState<string>("");
  const handleEditorChange = (content: any) => {
    setEditorContent(content);
  };


  const [buttonText, setButtonText] = useState(t('text.Next'));

  const [zoneOption, setzoneOption] = useState([
    { value: -1, label: t("text.id") },
  ]);

  const [wardOption, setwardOption] = useState([
    { value: -1, label: t("text.id") },
  ]);

  // const [itemOption, setitemOption] = useState([
  //   { value: "-1", label: t("text.itemMasterId"), details: "" },
  // ]);
  const [itemOption, setitemOption] = useState([
    { value: "-1", label: t("text.itemID") },
  ]);

  const [isResp, setResp] = useState(0);






  const [poleOption, setpoleOption] = useState([
    { value: "-1", label: t("text.poleInstChildId") },
  ]);

  const [empOption, setempOption] = useState<any>([]);
  const [complaintOptions, setComplaintOptions] = useState<any>([]);

  const [docOpen, setDocOpen] = useState(false);
  const [MaxComplainNoOption, setMaxComplainNoOption] = useState([
    { value: "-1", label: t("text.compId") },
  ]);

  const Userid = getId();


  const [compData, setCompData] = useState<any>([]);




  const formik: any = useFormik({
    initialValues: {




      "compId": 0,
      "itemID": null,
      "complaintType": "",
      "complaintDoc": "",
      "empId": '',
      "zoneid": 0,
      "wardid": 0,
      poleId: null,
      poleNo: "",
      "compainStatus": true,
      "approveEmp4": 0,
      "approveEmp3": 0,
      "approveEmp2": 0,
      "approveEmp1": 0,
      "complaint": "",
      "complaintNo": "",
      "createdBy": Userid,
      "updatedBy": "",
      "status": "",
      "currentReading": 0,
      "createdOn": defaultValues,
      "complaintDate": defaultValues,
      "updatedOn": defaultValues,
      "compAppdt": defaultValues,
      "compTypeId": 0,
      "compTypeName": "",
      "employee": {},

      "approveEmployee1": {},

      "approveEmployee2": {},

      "jobCardNo": "",
      "zoneName": "",
      "wardName": "",
      "empName": "",
      "srno": 0,
      "file": "",
      "image": "",
      "fileOldName": "",
      "totaldays": 0,
      "outDate": defaultValues,
      "outId": 0,
      "vehicleNo": "",
      "update": true,
      "approveEmpName1": "",
      "approveEmpName2": "",
      "approveEmpName3": "",
      "approveEmpName4": "",
      "deptName1": "",
      "deptName2": "",
      "deptName3": "",
      "deptName4": "",
      "desigName1": "",
      "desigName2": "",
      "desigName3": "",
      "desigName4": "",
      "inHouse": true,
      "outSource": false,
      "compStatusId": 2,
      "compStatusName": "Pending"

    },

    validationSchema: Yup.object({
      poleId: Yup.string()
        .required(t("text.reqPollNum")),
      itemID: Yup.string().required(t("text.reqItemName")),
      complaint: Yup.string()
        .required(t("Description  is required")),

    }),

    //defaultValues
    onSubmit: async (values) => {
      const response = await api.post(
        `ComplaintItem/AddUpdateComplaintItem`,
        values
      );

      if (response.data.status === 1) {
        setToaster(false);


        setTimeout(() => {
          toast.success(response.data.message);
        }, 200);

        getComplain(response.data.data);


        setResp(1);


        navigate("/complaint/ComplaintMaster");

      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });



  useEffect(() => {
    // getstoreData();
    // GetUnitData();
    getZoneData();
    // getWardData();
    GetitemData();
    GetempData();
    GetComplaintData();
    GetMaxComplainNo();
    getPoleData();



  }, []);


  const getComplain = async (compId: any) => {
    const collectData = { "compId": compId, "empId": -1, "zoneid": -1, "wardid": -1, "compTypeId": -1 };
    const response = await api.post(`ComplaintItem/GetComplaintItem`, collectData);
    const data = response.data.data;

    setCompData(data);
  };


  const getZoneData = async () => {
    const collectData = { zoneID: -1, user_ID: "" };
    const response = await api.post(`Zone/GetZonemaster`, collectData);
    const data = response.data.data;
    const arr = data.map((zone: any) => ({
      label: zone.zoneName,
      value: zone.zoneID,
    }));
    setzoneOption(arr);
  };

  const getPoleData = async (wardId = -1) => {
    const collectData = {
      poleInstId: -1,
      zoneId: -1,
      wardId: wardId,
    };
    const response = await api.post(`PoleInstallation/GetPoleNoZoneWardWise`, collectData);
    const data = response.data.data;
    const arr = data.map((pole: any) => ({
      label: pole.poleno,
      value: pole.poleInstChildId,
    }));
    setpoleOption(arr);
  };

  const getWardData = async (Id: any) => {
    const collectData = {
      areaID: -1,
      zoneID: Id
    };
    const res = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.areaName,
        value: item.areaID,
      })) || [];

    setwardOption(arr);
  };


  //   const getzoneData = async () => {
  //     const collectData = {
  //         "zoneID": -1,
  //         "user_ID": ""
  //     };
  //     const response = await api.post(`Zone/GetZonemaster`, collectData);
  //     const data = response.data.data;
  //     const arr = [];
  //     for (let index = 0; index < data.length; index++) {
  //         arr.push({
  //             label: data[index]["zoneName"],
  //             value: data[index]["zoneID"],
  //         });
  //     }
  //     setzoneOption(arr);
  // };

  // const getpoleData = async () => {
  //   const collectData = {
  //    "poleInstId": -1,
  //   "zoneId": -1,
  //   "wardId": -1
  //   };
  //   const response = await api.post(`PoleInstallation/GetPoleNoZoneWardWise`, collectData);
  //   const data = response.data.data;
  //   const arr = [];
  //   for (let index = 0; index < data.length; index++) {
  //       arr.push({
  //           label: data[index]["poleno"],
  //           value: data[index]["poleInstId"],
  //       });
  //   }
  //   setpoleOption(arr);
  // };
  // const getWardData = async () => {
  //     const collectData = {
  //         "areaID": -1
  //     };
  //     const response = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
  //     const data = response.data.data;
  //     const arr = [];
  //     for (let index = 0; index < data.length; index++) {
  //         arr.push({
  //             label: data[index]["areaName"],
  //             value: data[index]["areaID"],
  //         });
  //     }
  //     setwardOption(arr);
  // };
  const GetitemData = async () => {
    const collectData = {
      itemMasterId: -1,
    };
    const response = await api.post(`ItemMaster/GetItemMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemName"],
        value: data[index]["itemMasterId"]
      });
    }
    setitemOption(arr);
  };

  const GetComplaintData = async () => {
    const collectData = {
      compTypeId: -1,
    };
    const response = await api.post(`ComplainType/GetComplainType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["compTypeName"],
        value: data[index]["compTypeId"],
        details: data,
      });
    }
    setComplaintOptions(arr);
  };
  const GetempData = async () => {
    const collectData = {
      empid: -1,
      userId: "",
      empName: "",
      empMobileNo: "",
      empDesignationId: -1,
      empDeptId: -1,
      empStateId: -1,
      empCountryID: -1,
      empCityId: -1,
      empPincode: 0,
      roleId: ""
    };
    const response = await api.post(`EmpMaster/GetEmpmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["empName"],
        value: data[index]["empid"],
        details: data
      });
    }
    setempOption([{ value: "-1", label: t("text.empid"), details: "" }, ...arr]);
  };

  const GetMaxComplainNo = async () => {

    const response = await api.get(`ComplaintItem/GetMaxComplainNo`);
    const data = response.data.data;

    for (let index = 0; index < data.length; index++) {
      formik.setFieldValue("complaintNo", data[index]['complaintNo'])
    }
    //setmaxindentOption(arr);
  };


  const handlePanClose1 = () => {
    setDocOpen(false);
  };

  const modalOpenHandle1 = (event: string) => {
    setDocOpen(true);
    const base64Prefix = "data:image/jpg;base64,";

    let imageData = '';
    switch (event) {
      case "complaintDoc":
        imageData = formik.values.complaintDoc;
        break;
    }
    if (imageData) {
      console.log("imageData", base64Prefix + imageData);
      setImg(imageData);
    } else {
      setImg('');
    }
  };

  const otherDocChangeHandler = (event: any, params: any) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    if (!['jpg', 'png', 'jpeg'].includes(fileExtension || '')) {
      alert("Only .jpg ,png,jpeg image file is allowed to be uploaded.");
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const base64String = e.target?.result as string;
      const base64Data = base64String.split(',')[1];
      formik.setFieldValue(params, `data:image/png;base64,${base64Data}`);

      formik.setFieldValue('complaintDoc', fileExtension);



      console.log(`File '${file.name}' loaded as base64 string`);
      console.log("base64Data", base64Data);
    };
    reader.onerror = (error) => {
      console.error("Error reading file:", error);
      alert("Error reading file. Please try again.");
    };
    reader.readAsDataURL(file);
  };


  const back = useNavigate();






  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.CreateComplaint")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>

            <ToastContainer />
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>

              {/* <Grid item lg={4} xs={12}>
                <TextField
                  id="complaintNo"
                  name="complaintNo"
                  label={<CustomLabel text={t("text.complaintNos")} required={false} />}
                  value={formik.values.complaintNo}
                  placeholder={t("text.complaintNos")}
                  size="small"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid> */}

              <Grid item lg={4} xs={12}>
                <TextField
                  id="complaintNo"
                  name="complaintNo"
                  label={<CustomLabel text={t("text.complaintNos")} required={false} />}
                  value={formik.values.complaintNo}
                  //placeholder={t("text.AutoIndentForm")}
                  size="small"
                  fullWidth
                  InputLabelProps={{ "aria-readonly": true }}
                //onChange={formik.handleChange}
                //onBlur={formik.handleBlur}

                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="zone-dropdown"
                  options={zoneOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    const zoneId = newValue?.value || null;
                    formik.setFieldValue("zoneid", zoneId);
                    setwardOption([]); // Reset dependent dropdowns
                    setpoleOption([]);
                    if (zoneId) getWardData(zoneId);
                  }}
                  value={
                    zoneOption.find((opt) => opt.value === formik.values.zoneid) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.zoneId")} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="ward-dropdown"
                  options={wardOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    const wardId = newValue?.value || null;
                    formik.setFieldValue("wardid", wardId);
                    setpoleOption([]); // Reset dependent dropdowns
                    if (wardId) getPoleData(wardId);
                  }}
                  value={
                    wardOption.find((opt) => opt.value === formik.values.wardid) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.wardId")} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="pole-dropdown"
                  options={poleOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    formik.setFieldValue("poleNo", newValue?.label || null);
                    formik.setFieldValue("poleId", newValue?.value || null);
                  }}
                  value={
                    poleOption.find((opt) => opt.value === formik.values.poleId) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.SelectpoleNo")} required={true} />}
                    />
                  )}
                />
                {formik.touched.poleId && formik.errors.poleId && (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.poleId}</div>
                )}

              </Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={itemOption}
                  // value={
                  //   itemOption.find(
                  //         (opt) => opt.value === formik.values.itemID
                  //     ) || null
                  // }
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    //formik.setFieldValue("item", newValue?.label);
                    formik.setFieldValue("itemID", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.itemIDs")}
                          required={true}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.itemID && formik.errors.itemID && (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.itemID}</div>
                )}

              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={empOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("empId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.empId")}
                        />
                      }
                    />
                  )}
                />
              </Grid>




              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={complaintOptions}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("compTypeName", newValue?.label);
                    formik.setFieldValue("compTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.compType")}
                        />
                      }
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="complaintDate"
                  name="complaintDate"
                  label={
                    <CustomLabel
                      text={t("text.complaintDates")}
                      required={true}
                    />
                  }
                  type="date"
                  value={formik.values.complaintDate}
                  placeholder={t("text.complaintDates")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item lg={4} xs={12}>

              </Grid>



              {/* <Grid item lg={4} xs={12}></Grid>
              <Grid item lg={4} xs={12}>
                <FormControl component="fieldset">

                  <Box display="flex" alignItems="center">
                    <FormLabel component="legend" style={{ marginRight: '30px',fontWeight:"600"}}>
                      Complain :-   
                    </FormLabel>
                    <RadioGroup
                      row
                      name="complainSource"
                      value={formik.values.inHouse ? 'inHouse' : 'outSource'}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        if (selectedValue === 'inHouse') {
                          formik.setFieldValue('inHouse', true);
                          formik.setFieldValue('outSource', false);
                        } else if (selectedValue === 'outSource') {
                          formik.setFieldValue('inHouse', false);
                          formik.setFieldValue('outSource', true);
                        }
                      }}
                    >
                      <FormControlLabel
                        value="inHouse"
                        control={<Radio />}
                        label="In House"
                      />
                      <FormControlLabel
                        value="outSource"
                        control={<Radio />}
                        label="Out Source"
                      />
                    </RadioGroup>
                  </Box>
                </FormControl>
              </Grid>

              <Grid item lg={4} xs={12}></Grid>


 */}



              <Grid item lg={12} md={12} xs={12} marginTop={2}>
                <ReactQuill
                  id="complaint"
                  theme="snow"
                  value={formik.values.complaint}
                  onChange={(content) => formik.setFieldValue("complaint", content)}
                  onBlur={() => formik.setFieldTouched("complaint", true)}
                  modules={modules}
                  formats={formats}
                  //  style={{ backgroundColor: "white", minHeight: "200px" }} 
                  placeholder="Enter your complaint here"
                />

                {formik.touched.complaint && formik.errors.complaint && (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.complaint}</div>
                )}

              </Grid>


              <Grid container spacing={1} item>
                <Grid
                  xs={12}
                  md={4}
                  sm={4}
                  item
                  style={{ marginBottom: "30px", marginTop: "30px" }}
                >
                  <TextField
                    type="file"
                    inputProps={{ accept: "image/*" }}
                    InputLabelProps={{ shrink: true }}
                    label={<CustomLabel text={t("text.complaintDoc")} />}
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e) => otherDocChangeHandler(e, "image")}
                  />
                </Grid>
                <Grid xs={12} md={4} sm={4} item></Grid>

                <Grid xs={12} md={4} sm={4} item>
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      margin: "10px",
                    }}
                  >
                    {formik.values.complaintDoc == "" ? (
                      <img
                        src={nopdf}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                        }}
                      />
                    ) : (
                      <img
                        src={formik.values.image}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                          padding: "2px",
                        }}
                      />
                    )}
                    <Typography
                      onClick={() => modalOpenHandle1("image")}
                      style={{
                        textDecorationColor: "blue",
                        textDecorationLine: "underline",
                        color: "blue",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      {t("text.Preview")}
                    </Typography>
                  </Grid>
                </Grid>

                <Modal open={docOpen} onClose={handlePanClose1}>
                  <Box sx={style}>
                    {Img == "" ? (
                      <img
                        src={nopdf}
                        style={{
                          width: "170vh",
                          height: "75vh",
                        }}
                      />
                    ) : (
                      <img
                        alt="preview image"
                        src={Img}
                        style={{
                          width: "170vh",
                          height: "75vh",
                          borderRadius: 10,
                        }}
                      />
                    )}
                  </Box>
                </Modal>
              </Grid>





              {/* {isResp === 0 && ( */}

              <Grid item lg={6} sm={6} xs={12}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                  >
                    {t("text.save")}
                  </Button>
                </Grid>
              </Grid>
              {/* )} */}

              {/* {isResp === 0 && ( */}
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
              {/* )} */}


              {/* {isResp !== 0 && (
                <Grid item lg={6} sm={6} xs={12}>
                  <Button
                    fullWidth
                    onClick={() => {
                      navigate('/admin/ComplainApproval', {
                        state: compData[0],
                      });
                    }}
                    onMouseEnter={() => setButtonText('Moving to Complain Approval')}
                    onMouseLeave={() => setButtonText(t('text.Next'))}
                    style={{
                      backgroundColor: '#9999ff',
                      color: 'white',
                      marginTop: '10px',
                      position: 'relative',
                      padding: '14px 28px',
                      borderRadius: '30px',
                      fontWeight: '500',
                      letterSpacing: '1px',
                      transition: 'all 0.3s ease-in-out',
                      textTransform: 'none',
                      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)',
                    }}
                    sx={{
                      '&:hover': {
                        backgroundColor: '#9999ff',
                        transform: 'scale(1.05)',
                        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
                        borderRadius: '50px',
                        transition: 'all 0.3s ease-in-out',
                      },
                      '&:focus': {
                        outline: 'none',
                        boxShadow: '0 0 0 4px rgba(72, 140, 255, 0.5)',
                      },
                    }}
                  >


                    {buttonText}
                    {buttonText === 'Moving to Complain Approval' && (
                      <ArrowForwardIcon style={{ marginRight: '8px' }} />
                    )}
                  </Button>
                </Grid>
              )} */}




            </Grid>




          </form>
        </CardContent>
      </div>
    </div>
  )
}

const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }],
    [{ font: [] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["link", "image", "video", "formula"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "indent",
  "align",
  "link",
  "image",
  "video",
  "formula",
  "code-block",
];

export default CreateComplaint;